export default {
    slug: 'documents',
    title: 'Documents',
    visible: [
        'title',
        'pdf_status',
        'template.title'
    ],
    listview: 'DocumentListView',
    locales: ['common'],
    columns: [
        {
            key: 'title',
            main: true,
            filter: function (value) {
                return {
                    field: 'title',
                    operator: 'LIKE',
                    value: '%' + value + '%'
                };
            }
        }
    ],
    actions: {
        details: {
            title: 'Details',
            level: 'row',
            vm: 'goToDetails'
        },
        create: {
            title: 'Add new',
            level: 'highlight',
            icon: 'plus-circle',
            vm: 'addNew'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/documents/main/state.js